import { render, staticRenderFns } from "./zhuanxin.vue?vue&type=template&id=5af95081&scoped=true&"
import script from "./zhuanxin.vue?vue&type=script&lang=js&"
export * from "./zhuanxin.vue?vue&type=script&lang=js&"
import style0 from "./zhuanxin.vue?vue&type=style&index=0&id=5af95081&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af95081",
  null
  
)

export default component.exports